import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";
import { greyMui, purpleMui, rydeColors } from "@ryde/theme";

export const ErrorBoundaryLanguageSwitcherStyled = styled.div.attrs<IStyledAttributes>(
  {
    [DATA_E2E_KEY]: "error-boundary-language-switcher",
  },
)`
  position: absolute;
  top: 16px;
  inset-inline-end: 16px;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 3px;
  border-radius: 10px;
  border: 1px solid ${greyMui._200};
  background: ${greyMui._50};

  .error-boundary-language__button {
    appearance: none;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 44px;
    min-height: 32px;
    padding: 0 8px;
    border-radius: 8px;
    border: 1px solid transparent;
    background: transparent;
    color: ${greyMui._700};
    font-size: 12px;
    font-weight: 600;
    cursor: pointer;
    transition:
      background 0.15s ease,
      border-color 0.15s ease,
      color 0.15s ease;

    &:hover {
      background: ${rydeColors.white};
    }

    &:focus-visible {
      outline: 2px solid ${purpleMui._400};
      outline-offset: 1px;
    }

    &[aria-pressed="true"] {
      border-color: ${purpleMui._200};
      background: ${rydeColors.white};
      box-shadow: 0 1px 6px rgba(63, 45, 97, 0.14);
      color: ${purpleMui._700};
      font-weight: 700;
    }
  }
`;
